export default {
  userToken: '',
  refreshToken: '',
  refreshTokenExpireTime: '',
  // 企业信息 id、name、权限等级
  enterpriseId: '',
  sysUserName: '',
  role: '',
  userRouter: [],
  btnList: [],
  //组件数组
  itemArr: [],
  SaveStste: false,
  templateMarket: false
}



// WEBPACK FOOTER //
// ./src/store/states/index.js